import { render, staticRenderFns } from "./MaxDevicesInBasketModal.vue?vue&type=template&id=708f9fd2&scoped=true"
import script from "./MaxDevicesInBasketModal.vue?vue&type=script&lang=js"
export * from "./MaxDevicesInBasketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f9fd2",
  null
  
)

export default component.exports